import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import MobileSetup from "@/components/MobileSetup";
import { isNative } from "@/lib/mobile";

if (isNative) document.documentElement.classList.add("native-app");

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <MobileSetup><App /></MobileSetup>
    </QueryClientProvider>
  </React.StrictMode>,
);
